module.exports = __webpack_public_path__ + "assets/img/store-banner-04.287d3b38.png";